module.exports = __webpack_public_path__ + "img/volleyball_w.d3b20312.svg";